(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gvode-pasta-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.gvode-landing-form');
  if (!form || !window.fetch) return;
  event.preventDefault();
  if (form.dataset.pending === 'true') return;
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('.gvode-pasta__form-status');
  form.dataset.pending = 'true';button.disabled = true;
  status.setAttribute('role', 'status');status.textContent = 'Adding to cart…';
  try {
    const response = await fetch(`${form.action}.js`, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'This item could not be added to your cart.');
    form.dataset.pending = 'false';button.disabled = false;
    window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
  } catch (error) {
    status.setAttribute('role','alert');
    status.textContent = error instanceof TypeError ? 'We could not connect. Check your connection and try again.' : error.message;
    form.dataset.pending = 'false';button.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gvode-pasta-pilot"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gvode-pasta__campaign-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch) return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('.gvode-pasta__form-status');
      button.disabled = true;
      status.removeAttribute('role');
      status.textContent = 'Adding to cart…';
      try {
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This item could not be added to your cart.');
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (error) {
        status.setAttribute('role', 'alert');
        status.textContent = error instanceof TypeError ? 'We could not connect. Check your connection and try again.' : error.message;
        button.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
